import { gql } from '@apollo/client';

import buildLimitAndOffset from 'api/pagination/buildLimitAndOffset';
import SORTABLE_ANALYTICS_FILE_FIELDS from './SORTABLE_ANALYTICS_FILE_FIELDS';

export const ANALYTICS_FILES_QUERY = 'AnalyticsFilesList';

export const GET_ANALYTICS_FILES = gql`
  query ${ANALYTICS_FILES_QUERY}(
    $limit: Int!
    $offset: Int!
    $orderBy: [analytics_files_order_by!]
  ) {
    analyticsFilesAggregate: analytics_files_aggregate {
      aggregate {
        count
      }
    }
    analyticsFiles: analytics_files(
      limit: $limit
      offset: $offset
      order_by: $orderBy
    ) {
      id
      updatedAt
      pipelineId
      pipeline {
        id
        name
        writekey
        clusterId
        cluster {
          id
          name
          url
        }
      }
      analytics_file_identity_syncs {
        id
        identity_sync {
          id
          name
          friendlyName
        }
      }
    }
  }
`;

export function buildVariables({ page, perPage, sort }) {
  return {
    ...buildLimitAndOffset({ page, perPage }),
    orderBy: buildOrderBy(sort),
  };
}

function buildOrderBy(sort) {
  switch (sort.field) {
    case SORTABLE_ANALYTICS_FILE_FIELDS.pipeline: {
      return {
        pipeline: { name: sort.direction },
      };
    }
    default: {
      return { [sort.field]: sort.direction };
    }
  }
}
